module.exports = __webpack_public_path__ + "static/media/Purpose.84ad4621.svg";